export const environment = {
  production: true,
  apiUrl: 'https://toyota-intranet-api.issi.app/api',
  docsbotApiKey: 'ba10f6fa82d5b51561f5a548d19f74785dda71dbebfab310c55ed025b1017335',
  docsbotTeamId: "ZgsEbTfjQOsjWr2tYRfH",
  docsbotBotId: "ChTau3AsvaB9FidVbKRb"
};
